<template>
  <el-row>
    <el-col :span="24">
      <el-card class="data" v-loading="loading">
        <div class="data-title flex-space-between" slot="header">
          <p>New Releases</p>
          <div>
            <el-tooltip content="Insert" placement="top">
              <el-button
                type="success"
                circle
                icon="el-icon-check"
                @click.prevent="insert()"
              ></el-button>
            </el-tooltip>
            <Dialog />
          </div>
        </div>
        <Table />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Table from '../components/new-releases/Table'
import Dialog from '../components/new-releases/Dialog'
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
    Table,
    Dialog
  },

  computed: {
    ...mapState('newReleasesCarousel', ['loading'])
  },

  methods: {
    ...mapMutations('newReleasesCarousel', ['setDialog', 'setSelectedArtist']),
    insert() {
      this.setDialog(true)
    }
  }
}
</script>
